/**
 * Each race and Live tab's help page (the help site, help/docs, served at /help/). A tab added to a
 * race page without an entry here fails the type check, and a test checks every page exists, so
 * the help keeps step with the app.
 */
import { helpUrl } from "./HelpButton";

/** The finished-race page's tabs (RaceDetailPage `tabs`; Story only with a published story, the rest on phones). */
export type RaceTabId =
  | "position"
  | "story"
  | "cards"
  | "pitanalysis"
  | "cycle"
  | "laptimes"
  | "gaps"
  | "h2h"
  | "strategy"
  | "drivers";
/** RaceTrace Live's tabs (LiveRacePage `tabs`, and the page before the green). */
export type LiveTabId =
  "position" | "map" | "pitanalysis" | "laptimes" | "strategy" | "drivers";

/** Help pages, as paths under /help/. */
export const RACE_TAB_HELP: Record<RaceTabId, string> = {
  position: "race-pages/position-trace/",
  story: "race-pages/story/",
  cards: "race-pages/race-cards/",
  pitanalysis: "race-pages/pit-stops/",
  cycle: "race-pages/pit-cycle/",
  laptimes: "race-pages/lap-times/",
  gaps: "race-pages/gap-evolution/",
  h2h: "race-pages/head-to-head/",
  strategy: "race-pages/strategy/",
  drivers: "race-pages/driver-report/",
};

export const LIVE_TAB_HELP: Record<LiveTabId, string> = {
  position: "live/position-trace-and-gaps/",
  map: "live/track-map/",
  // Built from the race so far, they work as on a finished race: those pages say what differs live.
  pitanalysis: "race-pages/pit-stops/",
  laptimes: "race-pages/lap-times/",
  strategy: "live/live-strategy/",
  drivers: "race-pages/driver-report/",
};

/** Help pages for parts of a screen (InfoTip "More"). */
export const PART_HELP = {
  boxCall: "live/pit-ghost-and-box-call/",
  closing: "live/pit-ghost-and-box-call/",
  crossingOrder: "live/running-and-crossing-order/",
  driverReport: "race-pages/driver-report/",
  sectors: "race-pages/sectors/",
  qualifying: "qualifying/",
} as const;

export const raceTabHelp = (tab: RaceTabId): string => helpUrl(RACE_TAB_HELP[tab]);
export const liveTabHelp = (tab: LiveTabId): string => helpUrl(LIVE_TAB_HELP[tab]);
